import { render, staticRenderFns } from "./Rev.vue?vue&type=template&id=777c1fca&"
import script from "./Rev.vue?vue&type=script&lang=js&"
export * from "./Rev.vue?vue&type=script&lang=js&"
import style0 from "./Rev.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Rev.vue"
export default component.exports